import { render } from "./MonthlyTripTotalDataTable.vue?vue&type=template&id=3dbe22a6&scoped=true"
import script from "./MonthlyTripTotalDataTable.vue?vue&type=script&lang=js"
export * from "./MonthlyTripTotalDataTable.vue?vue&type=script&lang=js"

import "./MonthlyTripTotalDataTable.vue?vue&type=style&index=0&id=3dbe22a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbe22a6"]])

export default __exports__